import { useOrganizationData } from '@/contexts/OrganizationContext';

export const useOrganizationFeatures = () => {
  const { data, hasFeature } = useOrganizationData();

  return {
    hasFeature,
    enabledFeatures: data?.enabled_features || [],
    organizationName: data?.organization_name,
  };
};
